import React from "react";
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { format } from "date-fns";

interface ExpenseListProps {
  expenses: any[];
  onRefresh: () => void;
  loading: boolean;
}

const ExpenseList: React.FC<ExpenseListProps> = ({ expenses, loading }) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <Card>
        <CardContent className="pt-6">
          <p className="text-center">{t("common.loading")}</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("expenses.recentExpenses")}</CardTitle>
      </CardHeader>
      <CardContent>
        {expenses.length === 0 ? (
          <p className="text-center text-muted-foreground">{t("expenses.noExpenses")}</p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>{t("expenses.date")}</TableHead>
                <TableHead>{t("expenses.expenseTitle")}</TableHead>
                <TableHead>{t("expenses.category")}</TableHead>
                <TableHead>{t("expenses.paymentMethod")}</TableHead>
                <TableHead className="text-right">{t("expenses.amount")}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {expenses.map((expense) => (
                <TableRow key={expense.id}>
                  <TableCell>{format(new Date(expense.expense_date), "dd/MM/yyyy")}</TableCell>
                  <TableCell>{expense.title}</TableCell>
                  <TableCell>{expense.expense_categories?.name || "-"}</TableCell>
                  <TableCell>{t(`expenses.${expense.payment_method}`)}</TableCell>
                  <TableCell className="text-right">{expense.amount.toFixed(2)} TND</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};

export default ExpenseList;
